import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, firstValueFrom } from 'rxjs';
import { observable } from '@circlon/angular-tree-component/lib/mobx-angular/mobx-proxy';

@Injectable({
  providedIn: 'root'
})
export class LabelService {

  constructor(private httpClientService:HttpClientService) { }
  async removeLabelCompany(companyId:number,labelId:number){
    const observable : Observable<any> = this.httpClientService.delete({
      controller:ControllerType.CompanyLabel,
      queryString:`labelId=${labelId}`
    },companyId);
    return await firstValueFrom(observable);
  }

  async removeLabelProduct(productlabelId){
    const observable : Observable<any> = this.httpClientService.delete({
      controller:ControllerType.ProductLabel,
    },productlabelId);
    return await firstValueFrom(observable);
  }
}
